import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'planning.Calendar' | translate }}</h1>
            <ul class="actions01">
                <li><a class="btn filter" ng-click="vm.toggleFilter()">{{ 'filter.Filter events' | translate }}</a></li>
            </ul>
        </div>
        <planning-filter-calendar
            classifiers="vm.classifiers"
            filter="vm.filter"
            trainer-search="vm.trainerSearch"
            show-filter="vm.showFilter"
        />
        <div ui-calendar="vm.calendarSettings" calendar="trainings" class="calendar" ng-model="vm.events"></div>
    `
})
export default class {
    constructor ($scope, $sce, $, $compile, $translate, uiCalendarConfig, CalendarService) {
        this.CalendarService = CalendarService;
        this.uiCalendarConfig = uiCalendarConfig;
        this.$compile = $compile;
        this.$scope = $scope;
        this.$sce = $sce;
        this.$ = $;
        this.$translate = $translate;
        this.showFilter = false;
    }

    $onInit () {
        this.filter = {};
        this.events = [];
        /* Render Tooltip */
        this.$scope.htmlTooltip = this.$sce.trustAsHtml('<p></p>');
        this.initCalendar();
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
        this.trainerSearch = null;
    }

    initCalendar () {
        const { $compile, $scope } = this;
        this.calendarSettings = {
            editable: false,
            header: {
                left: 'prevYear, prev',
                center: 'title',
                right: 'next, nextYear'
            },
            timeFormat: 'HH:mm',
            fixedWeekCount: false,
            firstDay: 1,
            eventLimit: 5,
            eventLimitText: this.$translate.instant('calendar.more'),
            defaultView: this.getView(),
            handleWindowResize: true,
            events: (start, end, timezone, callback) => {
                this.filter.startDate = start.format(this.CalendarService.apiDateRequestFormat);
                this.filter.endDate = end.format(this.CalendarService.apiDateRequestFormat);
                this.CalendarService.updateEvents(this.filter, callback);
            },
            windowResize: () => {
                this.uiCalendarConfig.calendars.trainings.fullCalendar('changeView', this.getView());
            },
            eventRender: (event, element) => {
                element.attr({ 'uib-tooltip-html': 'htmlTooltip', 'tooltip-append-to-body': true });
                $compile(element)($scope);
            },
            eventMouseover: (event) => {
                this.$scope.htmlTooltip = this.$sce.trustAsHtml(this.CalendarService.getTooltip(event));
            }
        };
    }

    getView () {
        return this.$(window).width() < 768 ? 'listMonth' : 'month';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/planning/calendar/index.js